import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import AdminLogin from "@/components/admin/AdminLogin";
import AdminPanel from "@/components/admin/AdminPanel";

export default function Admin() {
  const [state, setState] = useState("checking");

  useEffect(() => {
    const token = localStorage.getItem("srs_admin_token");
    if (!token) return setState("out");
    api
      .get("/auth/me")
      .then(() => setState("in"))
      .catch(() => {
        localStorage.removeItem("srs_admin_token");
        setState("out");
      });
  }, []);

  if (state === "checking") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-ink">
        <span className="font-mono text-xs uppercase tracking-[0.3em] text-white/50">Checking session…</span>
      </div>
    );
  }

  if (state === "out") return <AdminLogin onSuccess={() => setState("in")} />;

  return (
    <AdminPanel
      onLogout={() => {
        localStorage.removeItem("srs_admin_token");
        setState("out");
      }}
    />
  );
}
